import desktopNavigation from '@wetransfer/transfer/component/navigation/menu/desktop';
import mobileNavigation from '@wetransfer/transfer/component/navigation/menu/mobile';
import Browser from '@wetransfer/transfer/modules/concorde-browser';
import Store from '@wetransfer/transfer/store';

export default {
  getItems(isLoading) {
    const { user } = Store.getState();

    if (Browser.isMobile) {
      return mobileNavigation.create(user, isLoading);
    }

    return desktopNavigation.create(user, isLoading);
  },

  getBackButtonItem(name, path) {
    return [{ name, path, withBackButton: true }];
  },

  getNotifications() {
    return {
      onboarding: { name: 'onboarding_success' },
      signin: { name: 'already_signed_in' },
    };
  },
};
